export { DeliveryPlaceholder } from './delivery-placeholder';
